<template>
  <div id="child-filter" class="child-filter">
    <div style="flex: 1">
      <input
        id="child-filter-text-query-input"
        type="text"
        class="form-control"
        placeholder="Filter kinderen - zoek op naam of school"
        v-model="globalChildByTextFilter"
      >
    </div>
    <div v-if="globalChildByTextFilter !== ''">
      <i
        @click="globalChildByTextFilter = ''"
        class="fa-light fa-xmark text-danger"
        style="font-size: 26px;"
      ></i>
    </div>
    <div
        v-if="showToggleGlobalChildByIdFilter"
        @click="toggleGlobalChildFilter()"
    >
        <icon v-if="globalChildByIdFilter.length > 0" name="filter-solid"></icon>
        <icon v-else name="filter"></icon>
    </div>
    <div
        v-if="showToggleSearch"
        id="toggle-search"
        @click="toggleSearch()"
    >
        <icon v-if="showSearch === true" name="child-list-solid"></icon>
        <icon v-else name="child-list"></icon>
    </div>
    <div
        class="d-none d-sm-block"
        v-if="showToggleSideNavbar"
        v-on:click="toggleSideNavbar()"
    >
        <icon name="bars"></icon>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";

export default {
  name: 'ChildFilter',
    components: {Icon},
  props: {
    /* @todo showToggleSideNavbar should be removed (move to top-bar component */
    showToggleSideNavbar: {
      type: Boolean,
      default: false,
    },
    showToggleGlobalChildByIdFilter: {
      type: Boolean,
      default: false
    },
    showToggleSearch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    globalChildByTextFilter: {
      get () {
        return this.$store.getters.globalChildByTextFilter
      },
      set (value) {
        this.$store.commit('SET_GLOBAL_CHILD_BY_TEXT_FILTER', value)
      }
    },
    showSearch () {
      return this.$store.getters.showSearch
    },
    showSideNavbar () {
      return this.$store.getters.showSideNavbar
    },
    showGlobalChildFilter () {
      return this.$store.getters.showGlobalChildFilter
    }
  },
  methods: {
    toggleGlobalChildFilter () {
      if (this.showGlobalChildFilter === true) {
        this.$store.commit('SET_SHOW_GLOBAL_CHILD_FILTER', false)
      } else {
        this.$store.commit('SET_SHOW_SEARCH', false)
        this.$store.commit('SET_SHOW_GLOBAL_CHILD_FILTER', true)
      }
    },
    toggleSideNavbar () {
      if (this.showSideNavbar === true) {
        this.$store.commit('SET_SHOW_SIDE_NAVBAR', false)
      } else {
        this.$store.commit('SET_SHOW_SIDE_NAVBAR', true)
      }
    },
    toggleSearch () {
      if (this.showSearch === true) {
        this.$store.commit('SET_SHOW_SEARCH', false)
      } else {
        this.$store.commit('SET_SHOW_GLOBAL_CHILD_FILTER', false)
        this.$store.commit('SET_SHOW_SEARCH', true)
      }
    }
  }
}
</script>

<style scoped>
#child-filter .fa,
#child-filter .far {
  color: rgb(53, 56, 60);
  margin-top: 2px;
}
#child-filter {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
#child-filter div:first-child {
  margin-right: 10px;
}
#child-filter div:last-child {
  margin-left: 10px;
}
#child-filter div:only-child {
  margin-left: 0;
  margin-right: 0;
}
#child-filter div:not(:first-child):not(:last-child) {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
